import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { TabPosition } from '@progress/kendo-angular-layout';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { RelationAccount } from '~/models/administration/account';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { StatusDto } from '~/models/modules/Asset/status';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { AccountsService } from '~/services/administration.ts/accounts';
import { GDataService } from '~/services/GDataService';
import { StatusesService } from '~/services/modules/assets/status';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { NoteComponent } from '~/shared/components/note/note.component';
import { PageState } from '~/shared/enums/stock-files.enum';

@Component({
    selector: 'status-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class StatusesUpsertComponent extends MultiSiteAwareComponent implements OnInit, OnDestroy {
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Status_StatusId') kendoInputStatusId: ElementRef;
  @ViewChild('note') note: NoteComponent;

  _theme: string;

  _currentUser: UserSummary;
  _isLiveEnterprise: boolean;

  _model: StatusDto;
  _active: boolean;
  _pageState: PageState;
  _page = 'statuses';
  _entity = 'Asset';
  _language = 'en';
  _permissionScope = 'statuses';

  okCloseSubscription: any = null;
  _gridFieldAuth: GridFieldAuthorization[];
  _editFormActive: boolean;
  _orderingTabsForm: boolean = false;
  _deactivatedFieldsForm: boolean = false;
  _isAddTabFormValue: boolean = false;

  _deactivatedFieldsGridData: Array<any> = [];
  _dataTabsSelected: Array<any> = [];

  _gridFieldText: GridFieldTextSummary[];

  _selectedLabelObjectCode: any;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _isMandatory: boolean = false;

  statusId: string;
  description: string;

  _kendoTabStripPosition: TabPosition = 'left';
  _dataTabs: Array<any> = [];
  _userNewDataTabs: Array<any> = [];
  _customFields: CustomFieldSummary[][] = [];
  _selectedAccountIds: any[] = [];
  _invalidSubmit: boolean;
  _customFieldsValue: any;
  _selectedLabelId: number;
  _selectedTabId: number;
  _custominvalidForm: boolean;
  _isCustomfieldsFormValue: boolean = false;
  _customTabs: any;

  _isEditForms: boolean = false;

  reactivate: boolean = false;
  reactivateItem: any;
  _selectableDataTabs: Array<any> = [];
  _allDataTabs: Array<any> = [];
  _customFieldsDictionary: { [key: string]: string } = {};
  _isOs: boolean;
  // #region Enterprise Data
  _addClassActive: boolean = false;
  _selectedAccounts: any[] = [];
  declare _tabEnabled: boolean;
  // #endregion
  constructor(
    private _statusesService: StatusesService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _sharedService: SharedService,
    private _securityService: SecurityService,
    private _themeManager: ThemeManagerService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _layoutManager: LayoutManagerService,
    private _dataService: GDataService,
    private _layoutComponent: LayoutComponent,
    private _accountsService: AccountsService) {
    super();
  }
  ngOnDestroy(): void {
  }
  ngOnInit(): void {
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    if (window.navigator.userAgent.indexOf('Mac') != -1) {
      this._isOs = true;
    };
    this.LoadData();
  }
  async LoadData() {
    this._isLiveEnterprise = environment.liveEnterprise;
    this._currentUser = this._securityService.currentUser;
    this._getdata();
    this.getAuth();
    this.getFormTabs();
    this.loadCustomFields(this._model?.id?.toString());
    await this.getCustomFields();
    await this.loadLabels();
    await this.fillForm();
  }
  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }
  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._selectableDataTabs = x;
        this._allDataTabs = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }
  private loadCustomFields(entityId?: string) {
    this._customFieldsService
      .getCustomFields(this._entity, this._page)

      .subscribe((data) => {
        if (this._model != null && this._model.id != null) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id;
          });
        }
        var tabIds = data.map(item => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(data, (item: { formTabId: any; }) => item.formTabId);
        let that = this;
        tabIds.forEach(function (formTabId) {
          that._customFields[formTabId] = grouped.get(formTabId);
        });
      });
    this._customFieldsService
      .getFormTabsByPage(this._page)

      .subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
      });
  }
  _reactivate(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response["message"] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response["message"],
                withoutConfirm: true
              });
              if (response["close"] != null) {
                if (response["close"] == true) {
                  this.loadCustomFields(this._model?.id?.toString());
                  this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            this._deactivatedFieldsForm = false;
          });
        this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });
    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    this.loadCustomFields(this._model?.id?.toString());
  }
  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }
  async fillForm() {
    if ((this._model && this._model.id > 0) || (this._pageState == PageState.ADD && this._model && this._model.description)) {
      this.statusId = this._model.statusId;
      this.description = this._model.description;
    }
  }
  getAuth() {
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }
  async getCustomFields() {
    this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)
      .pipe(finalize(() => { }))
      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      });
  }
  async loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
      })
  }
  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;

    if (this._pageState === PageState.ADD && this._model && this._model.id > 0) {
      this._model.id = null;
      this._model.statusId = null;
    }
    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
      this._selectedAccounts = (this._model?.assetStatusAccounts ?? []).map(
        (x: any) => +(x.account?.id ?? x.accountId ?? x.id ?? x)
      );
      this._selectedAccountIds = [...this._selectedAccounts];
    }
  }
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }
  runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        var result = data.result.toString()
        this.statusId = result;
      });
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoInputStatusId.nativeElement.focus();
        let departmentCode = this.kendoInputStatusId;
        departmentCode.nativeElement.classList.add('focusedInput');
      });
    }
  }
  generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService
      .getBarcode('status', quantity);
  }
  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      this._editFormActive = true;
      this._isCustomfieldsFormValue = true;
    }
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _onCancel() {
    this._closeForm(null);
  }
  _closeForm(model?: any) {
    var closeComponent = {
      component: 'statuses',
      isClosed: true,
      response: model
    }
    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('statuses');
    //this.ngOnDestroy();
    this._layoutManager.removeOverlay();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    //Quraim
    this._dataService.push(closeComponent);
    this._sharedService.model = {};
  }
  _onSave(e: string) {
    this.submit(e);
  }
  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
        this._deactivatedFieldsForm = true;
      });
  }
  _onEditForms() {
    this._isEditForms = true;
  }
  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }
  private submit = (e: string) => {
    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.',
        });
        return false;
      }
    }
    if (!this.statusId || this.statusId.length == 0) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please fill the status id',
        withoutConfirm: true
      });
      return false;
    }
    else {

      if (this._customFieldsValue) {
        const entries = Object.entries(this._customFieldsValue);
        for (const [index, [key, value]] of entries.entries()) {
          this._customFieldsDictionary[key] = `${value}`;
        }
      }
      var statusRequest: any = {
        statusId: this.statusId,
        description: this.description,
        customFieldsValue: this._customFieldsDictionary,
        accountIds: this._selectedAccounts.map((c: any) => (c?.accountId != null ? +c.accountId : +c))
      }
      if (!this._model || !this._model.id) {
        this._statusesService
          .createStatus(statusRequest)

          .subscribe((response: any) => {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                if (!this._currentUser.isEnterprise) {
                  this.note.createNote(response.responseId);
                }
                if (e === "saveAndClose") {
                  this._closeForm(statusRequest);
                }
                else if (e === "saveAndCopy") {
                  this.statusId = null;
                  this._pageState = PageState.ADD;
                }
                else if (e === "saveAndNew") {
                  this.statusId = null;
                  this.description = null;
                  this._model.id = null;
                  this._pageState = PageState.ADD;
                }
                else if (e === "save") {
                  this._pageState = PageState.EDIT;
                  if (response.responseId)
                    this._model.id = response.responseId;
                  this._model = { ...response.extraData.data };
                }
              }
              else {
                return;
              }
            }

          }

          );
      }
      else {
        this._statusesService
          .updateStatus(this._model.id, statusRequest)

          .subscribe((response: any) => {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });
            if (response['close'] != null) {
              if (response['close'] == true) {
                if (e === "saveAndClose") {
                  this._closeForm(statusRequest);
                }
                else if (e === "saveAndCopy") {
                  this.statusId = null;
                  this._pageState = PageState.ADD;
                }
                else if (e === "saveAndNew") {
                  this.statusId = null;
                  this.description = null;
                  this._model.id = null;
                  this._pageState = PageState.ADD;
                }
                else if (e === 'save') {
                  this._pageState = PageState.EDIT;
                }
              }
              else {
                return;
              }
            }
          }


          );
      }
    }
  }
  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }
  _edit() {
    this._pageState = PageState.EDIT;
  }
  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove("fullWidthFormForm");
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add("fullWidthFormForm");
    }
  }
  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)
      else
        result = null;

      return result ? result : null;
    }
  }
  _onTabSelect(e: any) {
    this._mobileMenuToggle();
  }
  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    Object.keys(customFieldsValue).forEach(key => {
      if (customFieldsValue[key] == null || customFieldsValue[key] == "null") {
        customFieldsValue[key] = "";
      }
      if (this._customFields[tabId].find(x => x.name == key).entityId == undefined) {//new mode, custom field data not added yet
        this._customFields[tabId].find(x => x.name == key).entityId = -1;
        this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: "null", entityId: -1, customFieldId: -1 });
      }
      var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
      if (customFieldData != undefined) {
        customFieldData.value = customFieldsValue[key];
      }
    });
    if (!this._customFieldsValue) {
      this._customFieldsValue = {};
    }
    Object.entries(customFieldsValue).map(([key, value]) => {
      this._customFieldsValue[key] = value;
    })
  }
  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          return;
        }
      }
    }
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }
  _addNewField(tabId: number) {
    this._selectedLabelId = null;
    this._selectedTabId = null
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }
  _deactivateTab(tabId: number, page: string) {
    let model: any = {
      customFieldEntityId: page == "locationTypes" ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService
      .deleteCustomTab(tabId, model)

      .subscribe((response: any) => {
        if (response != null && response["message"] != null) {
          this._customFieldsService
            .getFormTabsByPage(this._page)

            .subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
            });
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: response["message"],
            withoutConfirm: true
          });
          if (response["close"] != null) {
            if (response["close"] == true) {
              // this._closeForm();
            } else {
              return;
            }
          }
        }
        //   this._closeForm();
      });
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._selectableDataTabs = this._userNewDataTabs;
  }
  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._selectableDataTabs = x;
        this._closeOrderingTabsForm();
      })
  }
  _comboValueChange(e: any, i: number) {
    if (this._selectableDataTabs.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._selectableDataTabs.find(x => x.order == i + 1)).order =
        this._selectableDataTabs.find(x => x.name === e.name).order;
    }
    if (e) {
      this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
      this._dataTabsSelected[i] = e;
    }
    else {
      this._dataTabsSelected[i] = null;
    }
    this._selectableDataTabs = this._allDataTabs.filter(a => !this._dataTabsSelected.find(b => b === a));
  }
  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e);
  }
  _getAccounts = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  };
}
